import gql from 'graphql-tag';

import { ART_FRAGMENT } from '../fragments';

const queryName = 'art';

export const ENGAGEMENT = {
  queryName,
  queryBody: gql`
    query ${queryName}(
      $id: ID!
    ) {
      ${queryName}(
        id: $id
      ) {
        ...art
      }
    }
    ${ART_FRAGMENT}
  `,
};
